<template>
  <div class="overflow-hidden h-100">
    <div class="h-100">
      <div class="gallery-1 justify-content-center pb-20 h-100" :class="{'p-3': this.resultPage.isMobile}">
        <div class="placeholder" v-if="isPreviewThumbnailByOutputLoading()">
          <div class="animated-background"></div>
        </div>
        <div class="image h-100 bg-checkered" v-if="isPreviewThumbnailByOutputLoading() === false"><img :src="getThumbnailForOutput()"></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import ThumbnailManager from "../../../manager/ThumbnailManager";
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";

export default {
  name: "OutputImage",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
    this.generateThumbnail();
  },
  created: function () {
    this.generateThumbnail();

    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      this.generateThumbnail();
    });
  },
  methods: {
    generateThumbnail() {
      if (this.outputId === 'no_output_id') {
        return;
      }
      if (this.currentJob.state !== 'completed') {
        return;
      }

      ThumbnailManager.generateThumbnailPreview(this.currentJob, this.currentOutput);
    },
    getThumbnailForOutput(output) {
      return ThumbnailManager.getPreviewThumbnailByOutput(this.currentJob, this.currentOutput);
    },
    isPreviewThumbnailByOutputLoading(output) {
      if (this.outputId === 'no_output_id') {
        return true;
      }
      if (this.currentJob.state !== 'completed') {
        return true;
      }

      return ThumbnailManager.isPreviewThumbnailByOutputLoading(this.currentJob, this.currentOutput);
    },
  },
  computed: {
    image() {
      if (this.outputId === 'no_output_id') {
        return '';
      }

      return this.currentOutput.uri;
    }
  }
};
</script>
<style lang="scss" scoped>
.gallery-1 {
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.placeholder {
  margin: 0 auto;
  width: 100%;
  min-height: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius:9px;
  overflow: hidden;
}

@keyframes placeHolderShimmer{
  0%{
    background-position: -468px 0
  }
  100%{
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
}

.gallery-1 {
  display: flex;
  gap: 20px;

  img {
    object-fit: contain;
    object-position: top;
    height: 100%;
    width: 100%;
    padding-bottom: 20px;
  }
}

.image {
  object-fit: contain;
  object-position: top;
  display: flex;
  justify-content: center;
}

.loading .image,
.loading h4,
.loading .description {
  background-color: #383838;
  background: linear-gradient(
          100deg,
          rgba(255, 255, 255, 0) 40%,
          rgba(255, 255, 255, .1) 50%,
          rgba(255, 255, 255, 0) 60%
  ) #383838;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-in-out infinite;


}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
.bg-checkered{
    background-image:
      linear-gradient(45deg, #ccc 25%, transparent 25%), 
      linear-gradient(135deg, #ccc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #ccc 75%),
      linear-gradient(135deg, transparent 75%, #ccc 75%);
    background-size:25px 25px; /* Must be a square */
    background-position:0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px; /* Must be half of one side of the square */
    img{
      padding-bottom: 0px;
    }
  }
</style>
